<template>
  <Header />
  <!-- <BreadCrumb :valueFromParent="parentValue" /> -->
  <BreadCrumb
   title="Contact Us"        
        :breadcrumbs="[{ text: 'Contact Us', to: '/contact-us' }]"
  />
  <section class="about-us">
    <!-- Page-wrapper-Start -->
    <div class="page_wrapper">
      <!-- Preloader -->
      <!-- <div id="preloader">
        <div id="loader"></div>
      </div> -->

      <ContactArea />
      <MapArea />
    </div>

    <!-- Page-wrapper-End -->
  </section>

  <Newsletter />
  <Footer/>
</template>

<script setup>
import Header from "@/components/Header.vue";
import ContactArea from "@/components/ContactSection.vue";
import MapArea from "@/components/MapArea.vue";

import Newsletter from "@/components/NewsletterBox.vue";
import "@fortawesome/fontawesome-free/css/all.css";

import BreadCrumb from "@/components/BreadCrumb.vue";
import Footer from "@/components/FooterArea.vue";
import { ref, onMounted } from 'vue';
// export default {
//   name: "User_Login",
//   components: {
//     Header,
//     BreadCrumb,
//     ContactArea,
//     MapArea,
//     Newsletter,
//     Footer,
//   },
//   setup() {
//     // Define a reactive variable to hold the title
//     const pageTitle = ref('Salt - Contact Us');

//     // Function to update the title
//     const updateTitle = () => {
//       document.title = pageTitle.value;
//     };

//     // Call updateTitle when component is mounted
//     onMounted(() => {
//       updateTitle();
//     });

//     return {
//       pageTitle,
//       updateTitle
//     };
//   }

  
// };
</script>

<style scoped>

@keyframes animatop {
  0% {
    opacity: 0;
    bottom: -500px;
  }
  100% {
    opacity: 1;
    bottom: 0px;
  }
}

@keyframes animainfos {
  0% {
    bottom: 10px;
  }
  100% {
    bottom: -42px;
  }
}

@keyframes rotatemagic {
  0% {
    opacity: 0;
    transform: rotate(0deg);
    top: 0px;
    left: -30px;
  }
  100% {
    transform: rotate(-22deg);
    top: 0px;
    left: -108px;
  }
}

@keyframes rotatemagicc {
  0% {
    opacity: 0;
    transform: rotate(0deg);
    top: -30px;
    right: -30px;
  }
  100% {
    transform: rotate(-30deg);
    top: 0px;
    right: -108px;
  }
}
</style>
